export default __webpack_public_path__ + "static/media/Joshua_headshot.5e65856a.jpg";